import { useState, useEffect } from "react";
import api from "api/api";
import { Link, useNavigate } from "react-router-dom";

//Props Validations
import PropTypes from "prop-types";

//Material UI Components

// import mui icons
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

//import assets

//import component
import FiltersHeaderLabel from "../components/common/FiltersHeaderLabel";
import Header from "../components/common/Header";
import Loader from "../components/common/Loader";
import MainNavigation from "../components/common/MainNavigation";
import FilterAcrossProductsToggleComponent from "../components/common/FilterAcrossProductsToggleComponent";
import DataViewMode from "../components/common/DataViewMode";
import WeightToggleComponent from "../components/common/WeightToggleComponent";
import Reset from "../components/common/Reset";
import TTestDialog from "../components/common/TTest/TTestDialog";
import BeautyAndWellbeingTTestDialog from "components/common/TTest/BeautyAndWellbeingTTestDialog";
import AnalysisTypeSelector from "../components/common/AnalysisTypeSelector";
import OverallToggleComponent from "../components/common/OverallToggleComponent";
import ViewToggle from "../components/common/ViewToggle";
import FullScreenConatiner from "../components/layouts/FullScreenConatiner";
import InitialPopup from "../components/common/InitialPopup";
import AnalysisTable from "../components/common/analysisModule/AnalysisTable";
import AnalysisChart from "../components/common/analysisModule/chart/AnalysisChart";
import VariableVisibility from "../components/common/analysisModule/chart/VariableVisibility";
import AbsoluteCounts from "../components/common/analysisModule/AbsoluteCounts";

//redux
// redux
import { useSelector, useDispatch } from "react-redux";
import {
    loadClaimsAnalysisResultState,
    loadIsClaimsAnalysisResultLoadingState,
    loadAgreementAnalysisResultState,
    loadJustRightAnalysisResultState,
    loadDefaultJustRightAnalysisResultState,
    loadIsJustRightAnalysisResultLoadingState,
    loadIsAgreementAnalysisResultLoadingState,
    loadOverallAnalysisResultState,
    loadIsOverallAnalysisResultLoadingState,
    loadSecondaryAnalysisResultState,
    loadIsSecondaryAnalysisResultLoadingState,
    loadIsItmDataState,
    loadDefaultAgreementAnalysisResultState,
    loadDefaultOverallAnalysisResultState,
    loadDefaultSecondaryAnalysisResultState,
    loadDefaultClaimsAnalysisResultState,
} from "store/features/analysisResultsSlice";

import { resetTTestStore } from "store/features/ttestSlice";
import { toggleTextThemeSelection } from "store/features/textThemeSlice";
import { loadAgreementRemovedKpiListState } from "store/features/analysisKpiSlice";
import { showNotification } from "store/features/notificationSlice";
import { translateRemovedKpis } from "../utils/analysisTable/analysisUtils";
import { loadActiveTabState, clearPreserveModuleOnReturn } from "store/features/activeTabSlice";

// utils
import GetAgreementResult from "../utils/apis/GetAgreementResult";
import GetOverallResult from "../utils/apis/GetOverallResult";
import GetSecondaryResult from "../utils/apis/GetSecondaryResult";
import GetClaimsResult from "../utils/apis/GetClaimsResult";
import GetJustRightResult from "../utils/apis/GetJustRightResult";

function AgreementKpi({ headerTitle = "" }) {
    //REDUX
    const dispatch = useDispatch();
    const selectedStudy = useSelector((state) => state.studyDataStore.selectedStudies);

    const productsSecondaryDataState = useSelector((state) => state.analysisResultsStore.agreementAnalysisResult);
    const isLoading = useSelector((state) => state.analysisResultsStore.isAgreementAnalysisResultLoading);
    const weightToggle = useSelector((state) => state.analysisResultsStore.weightToggle);
    const isConsumerFilterSelected = useSelector((state) => state.consumerFilterStore.filterSelectionStatus);

    const productsOrder = useSelector((state) => state.productsInfoStore.productsOrder);
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    const productCategoryId = productCategoryData?.value || null;
    const navigationAvailability = useSelector((state) => state.studyDataStore.navigationAvailability);
    const [isTableShown, setIsTableShown] = useState(true);

    const [dataMappingData, setDataMappingData] = useState([]);

    const [isDataMappingDataLoading, setIsDataMappingDataLoading] = useState(false);
    const navigate = useNavigate();
    const sourceModuleName = "Agreement";

    // t-test details
    const [tTestResult, setTTestResult] = useState([]);
    const [testLabel, setTestLabel] = useState("");

    // Analysis type
    // box analysis code
    const overallBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.overallBoxAnalysisSelection);
    const secondaryBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.secondaryBoxAnalysisSelection);
    const agreementBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.agreementBoxAnalysisSelection);
    const claimsBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.claimsBoxAnalysisSelection);
    const analysisTypeValue = useSelector((state) => state.analysisTypeSelectionStore.agreementAnalysisTypeValue);
    const boxAnalysisTypeSelection = useSelector((state) => state.analysisTypeSelectionStore.agreementBoxAnalysisTypeSelection);
    const textThemeSelections = useSelector((state) => state.textThemeStore.selections);
    const [isFisher, setIsFisher] = useState(false);
    const [legends, setLegends] = useState([]);

    const activeTab = useSelector((state) => state.activeTabStore.activeTabByModule.agreement);
    const preserveModuleOnReturn = useSelector((state) => state.activeTabStore.preserveModuleOnReturn);
    const setActiveTab = (tab) => dispatch(loadActiveTabState({ moduleName: "agreement", tab }));

    // const [textThemeSelections, setTextThemeSelections] = useState({});
    // const [tTestPerformed, setTTestPerformed] = useState(false);
    // const [textThemeSelections, setTextThemeSelections] = useState({});
    // const handleTextThemeSelectionChange = (selections) => {
    //     setTextThemeSelections(selections);
    // };

    const [btnDisabled, setBtnDisabled] = useState({
        overallKpi: true,
        agreementKpi: true,
        claims: true,
        correlation: true,
        textAnalysis: true,
        fragranceDriver: true,
    });

    const isDeodorants = process.env?.REACT_APP_DEODORANTS?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isOralCare = process.env?.REACT_APP_ORAL_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCleansing = process.env?.REACT_APP_SKIN_CLEANSING?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCare = process.env?.REACT_APP_SKIN_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const jarOrJustRightVariableCategory = isHairCare || isSkinCare ? "JAR" : "Just Right";
    const isBeautyAndWellbeing = isHairCare || isSkinCare;
    const isUnileverFragranceHouse = process.env?.REACT_APP_UNILEVER_FRAGRANCE_HOUSE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const baseBtnArr = isOralCare || isSkinCleansing || isHairCare || isSkinCare 
        ? ["overallKpi", "justRight", "claims", ...(isHairCare ? ["fragranceDriver"] : []), "correlation"] 
        : isUnileverFragranceHouse ? ["overallKpi", "justRight", "correlation"] : ["overallKpi", "claims", "correlation"];

    const isHomeUseTest = selectedStudy[0]?.study_type__title === "Home Use Test";
    const hasOpenEnded = navigationAvailability?.has_open_ended_variables;
    const showTextAnalysisButton = isDeodorants && isHomeUseTest && hasOpenEnded;

    const btnArr = showTextAnalysisButton
        ? [...baseBtnArr, "textAnalysis"]
        : baseBtnArr;

    const selectedDataset = useSelector((state) => state.analysisResultsStore.selectedDataset);
    const removedKpiStoreState = useSelector((state) => state.analysisKpiStore.agreementRemovedKpiList);
    const isConceptRecallData = isHairCare && selectedDataset?.value === "concept_recall";
    const isConceptOnly = isHairCare && selectedDataset?.value === "concept";
    const isRecallOnly = isHairCare && selectedDataset?.value === "recall";
    // Translate removed KPIs when switching data view
    useEffect(() => {
        if (!dataMappingData?.columns?.length || !removedKpiStoreState?.length) return;
        let targetCategories;
        if (selectedDataset?.value === "concept") {
            targetCategories = ["Concept Agreement KPI"];
        } else if (selectedDataset?.value === "concept_recall") {
            targetCategories = ["Concept Agreement KPI", "Agreement KPI"];
        } else {
            targetCategories = ["Agreement KPI"];
        }
        const translated = translateRemovedKpis(removedKpiStoreState, dataMappingData.columns, targetCategories);
        dispatch(loadAgreementRemovedKpiListState(translated));
    }, [selectedDataset?.value]);

    // concept_recall shared variable visibility mappings
    const [conceptChartMappings, setConceptChartMappings] = useState([]);
    const [recallChartMappings, setRecallChartMappings] = useState([]);
    const conceptRecallMergedMappings = [...conceptChartMappings, ...recallChartMappings];

    const clearResult = () => {
        setTTestResult([]);
        setTestLabel("");
        dispatch(resetTTestStore());
        dispatch(toggleTextThemeSelection([]));

        // setTTestPerformed(false);
        // setConfidenceInterval("");
        // setTTestType("");
        // setTTestProducts("");
        // setTTestCoreDataId(null);
    };

    // clear T Test
    useEffect(() => {
        clearResult();
    }, [weightToggle]);

    useEffect(() => {
        if (preserveModuleOnReturn === "agreement") {
            dispatch(clearPreserveModuleOnReturn());
        } else {
            dispatch(loadActiveTabState({ moduleName: "agreement", tab: "" }));
        }
    }, []);

    useEffect(() => {
        if (isOralCare || isSkinCleansing) {
            if (!isLoading) {
                if (!isConsumerFilterSelected) {
                    InitialPopup.general();
                }
            }
        }
    }, [isLoading, isOralCare, isConsumerFilterSelected, isSkinCleansing]);

    const clearTtest = (product, type) => {
        // clear t test
        if (type === "consumerFilterAll") {
            clearResult();
        } else if (type === "consumerFilter") {
            const tTestPro = tTestResult?.[0]?.colors?.map((datum) => datum.productCode) || [];
            const cfPc = product?.split("_")?.join(" ") || "";
            if (tTestPro.indexOf(cfPc) !== -1) {
                clearResult();
            }
        }
    };

    const getAgreementResult = async ({ product = null, coreDataId = null, type = null, consumerFilter = null, pcs = [], selectedStudy = [], allAnalysisData = {}, fetchOnlyCurrent = false, boxAnalysisSelection = {} }) => {
        clearTtest(product, type);

        dispatch(loadIsAgreementAnalysisResultLoadingState(true));
        dispatch(loadIsOverallAnalysisResultLoadingState(true));
        dispatch(loadIsSecondaryAnalysisResultLoadingState(true));
        dispatch(loadIsClaimsAnalysisResultLoadingState(true));

        const agreementResult = await GetAgreementResult({ product, coreDataId, type, consumerFilter, pcs, selectedStudy, productsSecondaryDataState: allAnalysisData?.agreementAnalysisResult || [], productsOrder, productCategoryId, boxAnalysisSelection: boxAnalysisSelection["agreement"], isHairCare });
        if (agreementResult) {
            await dispatch(loadAgreementAnalysisResultState([...agreementResult]));
            if (!type) {
                dispatch(loadDefaultAgreementAnalysisResultState([...agreementResult]));
            }
        }
        dispatch(loadIsAgreementAnalysisResultLoadingState(false));

        const overallResult = await GetOverallResult({ product, coreDataId, type, consumerFilter, pcs, selectedStudy, productsSecondaryDataState: allAnalysisData?.overallAnalysisResult || [], productsOrder, productCategoryId, boxAnalysisSelection: boxAnalysisSelection["overall"], isHairCare });
        if (overallResult) {
            overallResult.forEach((product) => {
                product.scores.forEach((ele) => {
                    if (ele.backendVariable.includes("ITM_") && ele.mean) {
                        dispatch(loadIsItmDataState(true));
                    }
                });
            });
            dispatch(loadOverallAnalysisResultState([...overallResult]));
            if (!type) {
                dispatch(loadDefaultOverallAnalysisResultState([...overallResult]));
            }
        }

        const claimsResult = await GetClaimsResult({ product, coreDataId, type, consumerFilter, pcs, selectedStudy, productsSecondaryDataState: allAnalysisData?.claimsAnalysisResult || [], productsOrder, productCategoryId, boxAnalysisSelection: boxAnalysisSelection["claims"] });
        if (claimsResult) {
            dispatch(loadClaimsAnalysisResultState([...claimsResult]));
            if (!type) {
                dispatch(loadDefaultClaimsAnalysisResultState([...claimsResult]));
            }
        }

        const secondaryResult = await GetSecondaryResult({ product, coreDataId, type, consumerFilter, pcs, selectedStudy, productsSecondaryDataState: allAnalysisData?.secondaryAnalysisResult || [], productsOrder, productCategoryId, boxAnalysisSelection: boxAnalysisSelection["secondary"], isHairCare });
        if (secondaryResult) {
            dispatch(loadSecondaryAnalysisResultState([...secondaryResult]));
            if (!type) {
                dispatch(loadDefaultSecondaryAnalysisResultState([...secondaryResult]));
            }
        }

        if (!isDeodorants) {
            dispatch(loadIsJustRightAnalysisResultLoadingState(true));
            const justRightResult = await GetJustRightResult(product, coreDataId, type, consumerFilter, pcs, selectedStudy, allAnalysisData?.justRightAnalysisResult || [], productsOrder, productCategoryId, jarOrJustRightVariableCategory);
            dispatch(loadJustRightAnalysisResultState([...justRightResult]));
            if (!type) {
                dispatch(loadDefaultJustRightAnalysisResultState([...justRightResult]));
            }
            dispatch(loadIsJustRightAnalysisResultLoadingState(false));
        }

        dispatch(loadIsOverallAnalysisResultLoadingState(false));
        dispatch(loadIsSecondaryAnalysisResultLoadingState(false));
        dispatch(loadIsClaimsAnalysisResultLoadingState(false));
        console.log("fetchOnlyCurrent", fetchOnlyCurrent);
    };

    const handleError = (type, error) => {
        dispatch(showNotification({ severity: type, data: error }));
    };

    const compareArrays = (arr1, arr2) => {
        const arrSorted2 = arr2.slice().sort();
        const isArrEqual =
            arr1.length === arr2.length &&
            arr1
                .slice()
                .sort()
                .every((value, index) => {
                    return value === arrSorted2[index];
                });
        return isArrEqual;
    };
    
    useEffect(() => {
        let _selectedStudies = selectedStudy;
        let disabled = true;
        let _country = _selectedStudies[0]?.country__title;
        let _deodorantFormat = _selectedStudies[0]?.format_data;

        if (isOralCare) {
            disabled = false;
        } else {
            _selectedStudies.forEach((each) => {
                if (each.country__title === _country && compareArrays(each.format_data, _deodorantFormat)) {
                    disabled = false;
                } else {
                    disabled = true;
                }
            });
        }

        let disableBtn = !_selectedStudies.length > 0;
        let tempObj = {
            overallKpi: disableBtn,
            agreementKpi: disableBtn,
            claims: disableBtn,
            correlation: disabled,
        };
        setBtnDisabled(tempObj);
    }, [selectedStudy, isOralCare]);

    useEffect(() => {
        async function fetchDataMappingData() {
            const studyType = selectedStudy.length > 0 ? [...new Set(selectedStudy.map((ele) => ele.study_type))].join(", ") : null;
            const studyTypeMethod = selectedStudy.length > 0 ? [...new Set(selectedStudy.map((ele) => ele.study_type_method))].join(", ") : null;
            try {
                const variableCategoryAgreement = isHairCare ? "Agreement KPI,Concept Agreement KPI" : "Agreement KPI";
                let url = process.env.REACT_APP_SERVER_PATH + `/data-mappings/all/?archive=false&uniq=true&variable_category=${encodeURIComponent(variableCategoryAgreement)}`;

                if (productCategoryId) {
                    url += `&product_category=${productCategoryId}`;
                }
                if (studyType) {
                    url += `&study_type=${studyType}`;
                }
                if (studyTypeMethod) {
                    url += `&study_type_method=${studyTypeMethod}`;
                }
                setIsDataMappingDataLoading(true);
                await api
                    .get(url)
                    .then(async (res) => {
                        setDataMappingData(res.data);
                        setIsDataMappingDataLoading(false);
                    })
                    .catch((error) => {
                        handleError("error", error);
                        setIsDataMappingDataLoading(false);
                    });
            } catch (error) {
                handleError("error", error);
                setIsDataMappingDataLoading(false);
            }
        }
        const fetchAnalysisResult = async () => {
            if (!productsSecondaryDataState.length) {
                await getAgreementResult({
                    product: null,
                    coreDataId: null,
                    type: null,
                    consumerFilter: null,
                    pcs: [],
                    selectedStudy,
                    allAnalysisData: [],
                    fetchOnlyCurrent: true,
                    boxAnalysisSelection: {
                        overall: overallBoxAnalysisSelection,
                        secondary: secondaryBoxAnalysisSelection,
                        agreement: agreementBoxAnalysisSelection,
                        claims: claimsBoxAnalysisSelection,
                    },
                });
            }
        };

        if (selectedStudy.length === 0) {
            navigate("/studies");
        } else {
            fetchAnalysisResult();
            fetchDataMappingData();
        }
    }, [selectedStudy, productsSecondaryDataState, productCategoryId]);

    // Clear the removed KPI data from the Redux store on page change to reset the default view.
    // Remove the code below if you want to retain the removed variables.
    useEffect(() => {
        return () => {
            dispatch(loadAgreementRemovedKpiListState([]));
        };
    }, [dispatch]);

    // const onTTestDataReceived = (tTest, tTestConfidenceInterval, testType, testProducts, tTestCoreDataId, tTestAnalysisType) => {
    //     setTTestPerformed(tTest);
    //     setConfidenceInterval(tTestConfidenceInterval);
    //     setTTestType(testType);
    //     setTTestProducts(testProducts);
    //     setTTestCoreDataId(tTestCoreDataId);
    //     setTTestAnalysisType(tTestAnalysisType);
    // };

    const hasActiveTextThemeSelection = textThemeSelections.some(item => item.isSelected === true);
    const finalBtnDisabledObj = { ...btnDisabled };

    if (hasActiveTextThemeSelection) {
        btnArr.forEach(btn => {
            finalBtnDisabledObj[btn] = true;
        });
        finalBtnDisabledObj.textAnalysis = false;
    } else {
        if (showTextAnalysisButton) {
            finalBtnDisabledObj.textAnalysis = true;
        }
    }

    return (
        <>
            {(isLoading || isDataMappingDataLoading) && <Loader />}
            <Header
                title={headerTitle}
                isStudySelected={true}
            // tTestPerformed={tTestPerformed}
            // confidenceInterval={confidenceInterval}
            // tTestType={tTestType}
            // tTestProducts={tTestProducts}
            // tTestCoreDataId={tTestCoreDataId}
            // tTestAnalysisType={tTestAnalysisType}
            />
            <div
                className="ms-4 me-4 mb-0 mt-3 background-color-white box-shadow--2 d-flex"
                style={{
                    borderRadius: "5px",
                }}
            >
                <FiltersHeaderLabel multipleLabel={true} />
            </div>
            <FullScreenConatiner>
                <div
                    className=""
                    style={{
                        width: 150,
                        display: "flex",
                        alignItems: "center",
                        position: "absolute",
                        zIndex: 1,
                    }}
                >
                    <Link
                        to="/studies"
                        onClick={(e) => {
                            if (window.history.length > 2) {
                                e.preventDefault();
                                navigate(-1);
                            }
                        }}
                    >
                        <div
                            className="p-2 liner-light-blue-background color-white"
                            style={{
                                borderRadius: "50%",
                                position: "relative",
                                top: -15,
                                left: -15,
                                cursor: "pointer",
                            }}
                        >
                            <span>
                                <ArrowBackIcon className="color-white" />
                            </span>
                        </div>
                    </Link>
                </div>

                <div
                    className="card-btns"
                    style={{
                        padding: "20px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            zIndex: 9,
                        }}
                    >
                        <div
                            style={{
                                marginBottom: "5px",
                                marginRight: "5px",
                            }}
                        >
                            <ViewToggle
                                value={isTableShown}
                                setValue={setIsTableShown}
                                labels={["Table", "Chart"]}
                            />
                        </div>
                        <div
                            style={{
                                marginLeft: "1rem",
                                zIndex: "3",
                                width: "150px",
                            }}
                        >
                            <AnalysisTypeSelector
                                value={analysisTypeValue}
                                pageName="agreementKpiAnalysis"
                                variableCategory={isHairCare ? "Agreement KPI,Concept Agreement KPI": "Agreement KPI"}
                                handleFilterSubmit={getAgreementResult}
                                mappings={dataMappingData.columns}
                                moduleName="agreement"
                                clearResult={clearResult}
                            />
                        </div>
                        {analysisTypeValue?.value === "box_analysis" && isOralCare &&
                            <AbsoluteCounts
                                moduleName="agreement"
                            />
                        }
                    </div>

                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            flexWrap: "wrap",
                        }}
                    >
                        <OverallToggleComponent />
                        <WeightToggleComponent />
                        <FilterAcrossProductsToggleComponent />
                        {isHairCare && <DataViewMode />}
                        {isBeautyAndWellbeing ? (
                            <BeautyAndWellbeingTTestDialog
                                variableCategory="Agreement KPI"
                                functionsSettings={{
                                    setIsFisher: setIsFisher,
                                    setLegends: setLegends,
                                    setTTestResult: setTTestResult,
                                    setTestLabel: setTestLabel,
                                    clearResult: clearResult,
                                    // onTTestDataReceived: onTTestDataReceived,
                                }}
                                analysisLevelData={{
                                    moduleName: "agreement",
                                    analysisTypeValue: analysisTypeValue,
                                    boxAnalysisTypeSelection: boxAnalysisTypeSelection,
                                    boxAnalysisSelection: agreementBoxAnalysisSelection,
                                }}
                                tabData={{
                                    productsSecondaryDataState: productsSecondaryDataState,
                                }}
                            />
                        ) : (
                            <TTestDialog
                                variableCategory="Agreement KPI"
                                functionsSettings={{
                                    setIsFisher: setIsFisher,
                                    setLegends: setLegends,
                                    setTTestResult: setTTestResult,
                                    setTestLabel: setTestLabel,
                                    clearResult: clearResult,
                                    // onTTestDataReceived: onTTestDataReceived,
                                }}
                                analysisLevelData={{
                                    moduleName: "agreement",
                                    analysisTypeValue: analysisTypeValue,
                                    boxAnalysisTypeSelection: boxAnalysisTypeSelection,
                                    boxAnalysisSelection: agreementBoxAnalysisSelection,
                                    mappings: dataMappingData.columns,
                                }}
                                tabData={{
                                    productsSecondaryDataState: productsSecondaryDataState,
                                }}
                            />
                        )}
                        <Reset clearTTestResult={clearResult} />
                    </div>
                </div>
                {productsSecondaryDataState.length !== 0 && dataMappingData.length !== 0 && (
                    <div
                        style={{
                            minHeight: "calc(100vh - 300px)",
                            padding: "20px",
                        }}
                    >
                        {isTableShown ? (
                            <>
                                <AnalysisTable
                                    productsSecondaryData={productsSecondaryDataState}
                                    handleFilterSubmit={getAgreementResult}
                                    selectedStudy={selectedStudy}
                                    analysisLevelData={{
                                        tableConfig: {
                                            stickyColumns: ["KPI"],
                                        },
                                        moduleName: "agreement",
                                        analysisTypeValue: analysisTypeValue,
                                        boxAnalysisTypeSelection: boxAnalysisTypeSelection,
                                        boxAnalysisSelection: agreementBoxAnalysisSelection,
                                        mappings: dataMappingData.columns,
                                    }}
                                    tTest={{
                                        tTestLegends: legends,
                                        isFisher: isFisher,
                                        tTestResult: tTestResult,
                                        testLabel: testLabel,
                                    }}
                                    settings={{
                                        activeTab: activeTab,
                                        setActiveTab: setActiveTab,
                                    }}
                                />
                                {/* <ComparisonTable
                                    selectedStudy={selectedStudy}
                                    productsSecondaryData={productsSecondaryDataState}
                                    dataMappingData={dataMappingData}
                                    activeMacroCategory={activeMacroCategory}
                                    column1={column1}
                                    column2={column2}
                                    tTestResult={tTestResult}
                                    testLabel={testLabel}
                                    handleFilterSubmit={getAgreementResult}
                                /> */}
                            </>
                        ) : isConceptRecallData || isConceptOnly || isRecallOnly ? (
                            <>
                                {(isConceptRecallData || isConceptOnly || isRecallOnly) && (
                                    <VariableVisibility
                                        mappings={isConceptRecallData ? conceptRecallMergedMappings : isConceptOnly ? conceptChartMappings : recallChartMappings}
                                        moduleName="agreement"
                                    />
                                )}
                            <div
                                style={{
                                    minHeight: "calc(-300px + 100vh)",
                                    display: "flex",
                                    justifyContent: isConceptOnly || isRecallOnly ? "flex-start" : "space-between",
                                    height: "100%",
                                }}
                            >
                                <div
                                    style={{
                                        width: isConceptOnly || isRecallOnly ? "100%" : "49%",
                                        borderTop: isConceptRecallData ? "1px solid #c8c8c8" : "none",
                                        borderRight: isConceptRecallData ? "1px solid #c8c8c8" : "none",
                                        paddingTop: "20px",
                                        marginTop: "10px",
                                        height: "100%",
                                    }}
                                >
                                    <div style={{ textAlign: "center", marginBottom: "20px" }}>
                                        {isConceptRecallData  ? "Concept" : ""}
                                    </div>
                                    <AnalysisChart
                                        productsSecondaryData={productsSecondaryDataState}
                                        analysisLevelData={{
                                            isConceptDataShown: isConceptRecallData || isConceptOnly,
                                            isRecallDataShown: isRecallOnly,
                                            isSplitConceptRecall: isConceptRecallData,
                                            moduleName: "agreement",
                                            analysisTypeValue: analysisTypeValue,
                                            boxAnalysisTypeSelection: boxAnalysisTypeSelection,
                                            boxAnalysisSelection: agreementBoxAnalysisSelection,
                                            mappings: dataMappingData.columns,
                                        }}
                                        onVariableVisibilityMappingsChange={isConceptRecallData || isConceptOnly ? setConceptChartMappings : setRecallChartMappings}
                                        settings={{ activeTab: activeTab, setActiveTab: setActiveTab }}
                                        tTest={{ tTestLegends: legends, isFisher: isFisher, tTestResult: tTestResult, testLabel: testLabel }}
                                    />
                                </div>
                                {isConceptRecallData && (
                                    <div
                                        style={{
                                            width: "49%",
                                            borderTop:  isConceptRecallData ? "1px solid #c8c8c8" : "none",
                                            borderRight: isConceptRecallData ? "1px solid #c8c8c8" : "none",
                                            paddingTop: "20px",
                                            marginTop: "10px",
                                            height: "100%",
                                        }}
                                    >
                                        <div style={{ textAlign: "center", marginBottom: "20px" }}>Recall</div>
                                        <AnalysisChart
                                            productsSecondaryData={productsSecondaryDataState}
                                            analysisLevelData={{
                                                isRecallDataShown: true,
                                                isSplitConceptRecall: true,
                                                moduleName: "agreement",
                                                analysisTypeValue: analysisTypeValue,
                                                boxAnalysisTypeSelection: boxAnalysisTypeSelection,
                                                boxAnalysisSelection: agreementBoxAnalysisSelection,
                                                mappings: dataMappingData.columns,
                                            }}
                                            onVariableVisibilityMappingsChange={setRecallChartMappings}
                                            settings={{ activeTab: activeTab, setActiveTab: setActiveTab }}
                                            tTest={{ tTestLegends: legends, isFisher: isFisher, tTestResult: tTestResult, testLabel: testLabel }}
                                        />
                                    </div>
                                )}
                            </div>
                            </>
                        ) : (
                            <AnalysisChart
                                productsSecondaryData={productsSecondaryDataState}
                                analysisLevelData={{
                                    moduleName: "agreement",
                                    analysisTypeValue: analysisTypeValue,
                                    boxAnalysisTypeSelection: boxAnalysisTypeSelection,
                                    boxAnalysisSelection: agreementBoxAnalysisSelection,
                                    mappings: dataMappingData.columns,
                                }}
                                settings={{
                                    activeTab: activeTab,
                                    setActiveTab: setActiveTab,
                                }}
                                tTest={{
                                    tTestLegends: legends,
                                    isFisher: isFisher,
                                    tTestResult: tTestResult,
                                    testLabel: testLabel,
                                }}
                            />
                            // <AnalysisChart
                            //     selectedStudy={selectedStudy}
                            //     // productsRow={productsRow}
                            //     productsSecondaryData={productsSecondaryDataState}
                            //     dataMappingData={dataMappingData}
                            //     //activeMacroCategory={activeMacroCategory}
                            //     column1={[activeMacroCategory]}
                            //     column2={[activeMacroCategoryDisplayLabels]}
                            //     tTestResult={tTestResult}
                            //     chartType={chartType}
                            //     analysisType={"agreementKpiAnalysis"}
                            //     colorsType={"agreementKpiAnalysis"}
                            //     legends={legends}
                            //     componentName={"agreementKpiDataState"}
                            //     pageName={"agreementKpiAnalysis"}
                            //     dataView={isDeodorants ? top2BoxToggle : dataView}
                            //     testLabel={testLabel}
                            //     removedList={removedList}
                            // />
                        )}
                    </div>
                )}
                <div
                    style={{
                        position: "relative",
                        top: "5px",
                        marginTop: "30px",
                    }}
                >
                    <MainNavigation
                        buttons={btnArr}
                        btnDisabledObj={finalBtnDisabledObj}
                        textThemeNavState={{ from: sourceModuleName }}
                    />
                </div>
            </FullScreenConatiner>
        </>
    );
}

// Typechecking props for the AgreementKpi
AgreementKpi.propTypes = {
    headerTitle: PropTypes.string,
};

export default AgreementKpi;
